document.addEventListener('DOMContentLoaded', () => {

	const filterDD = document.querySelectorAll('.filter-item--dd');
	if (filterDD) {
		filterDD.forEach(item => {
			item.addEventListener('click', (e) => {
				item.classList.toggle('active');
			});

		});
		document.addEventListener('click', (e) => {
			filterDD.forEach(item => {
				if (!item.contains(e.target)) {
					item.classList.remove('active');
				}
			});
		});
	}

	const counters = document.querySelectorAll('.counter-grid__number span');
	const options = {
		root: null,
		rootMargin: '0px',
		threshold: 0.5
	};

	const callback = (entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const counter = entry.target;
				const targetNumber = parseInt(counter.dataset.target, 10);
				let currentNumber = 0;
				const increment = Math.ceil(targetNumber / 100);

				const updateCounter = () => {
					currentNumber += increment;
					if (currentNumber > targetNumber) {
						currentNumber = targetNumber;
					}
					counter.textContent = currentNumber;
					if (currentNumber < targetNumber) {
						requestAnimationFrame(updateCounter);
					}
				};
				updateCounter();
				observer.unobserve(counter);
			}
		});
	};

	const observer = new IntersectionObserver(callback, options);
	counters.forEach(counter => {
		observer.observe(counter);
	});


	document.querySelectorAll('.partners__carousel').forEach(carousel => {
		const track = carousel.querySelector('.swiper-wrapper');

		const slides = Array.from(track.children);
		slides.forEach(slide => {
			track.appendChild(slide.cloneNode(true));
		});

		let speed = 40; // px per second
		let position = 0;
		let lastTime = null;
		let paused = false;

		const trackWidth = track.scrollWidth / 2;

		carousel.addEventListener('mouseenter', () => {
			paused = true;
		});

		carousel.addEventListener('mouseleave', () => {
			paused = false;
			lastTime = null;
		});

		function animate(time) {
			if (!lastTime) lastTime = time;

			if (!paused) {
				const delta = (time - lastTime) / 1000;
				position -= speed * delta;

				if (Math.abs(position) >= trackWidth) {
					position = 0;
				}

				track.style.transform = `translateX(${position}px)`;
			}

			lastTime = time;
			requestAnimationFrame(animate);
		}

		requestAnimationFrame(animate);
	});

	const articleSliders = document.querySelectorAll('.articles-grid-items--slider');

	articleSliders.forEach(slider => {
		let swiperInstance = null;

		const initSwiper = () => {
			if (window.innerWidth > 767) {
				if (!swiperInstance) {
					swiperInstance = new Swiper(slider, {
						slidesPerView: 3,
						speed: 800,
						spaceBetween: 20,
						slidesPerGroup: 2,
						navigation: {
							nextEl: slider.querySelector('.slider-nav__btn--next'),
							prevEl: slider.querySelector('.slider-nav__btn--prev'),
						},
						pagination: {
							el: slider.querySelector('.slider-pagination'),
							clickable: true,
						},
						autoplay: {
							delay: 5000,
							disableOnInteraction: false,
						},
					});
				}
			} else {
				if (swiperInstance) {
					swiperInstance.destroy(true, true);
					swiperInstance = null;
				}
			}
		};

		initSwiper();

		window.addEventListener('resize', initSwiper);
	});




	const textImageSliders = document.querySelectorAll('.text-image-slider, .text-image-slider-old');
	textImageSliders.forEach(slider => {
		const swiper = new Swiper(slider, {
			loop: true,
			spaceBetween: 20,
			navigation: {
				nextEl: slider.querySelector('.slider-nav__btn--next'),
				prevEl: slider.querySelector('.slider-nav__btn--prev'),
			},
			pagination: {
				el: slider.querySelector('.slider-pagination'),
				clickable: true,
			},
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			brakepoints: {
				320: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				640: {
					slidesPerView: 1,
					spaceBetween: 0,
				},
				1024: {
					slidesPerView: 1,
					spaceBetween: 0,
				},
			},
			on: {
				init: function () {
					const totalSlides = this.slides.length;
					const slidesPerView = this.params.slidesPerView;
					if (totalSlides <= slidesPerView) {
						slider.querySelector('.slider-nav').style.display = 'none';
					} else {
						slider.querySelector('.slider-nav').style.display = 'flex';
					}
				},
				// add to image wrap class active on slide change
				slideChange: function () {
					setTimeout( function () {

						const prevOld = slider.querySelectorAll('.text-image-slider-old__image');
						const prev = slider.querySelectorAll('.text-image-slider__image');
						if (prevOld) {
							prevOld.forEach(prev => {
								prev.classList.remove('active');
							});
						}
						if (prev) {
							prev.forEach(prev => {
								prev.classList.remove('active');
							});
						}
						const activeSlide = slider.querySelector('.swiper-slide-active');
						const imgWrapOld = activeSlide.querySelector('.text-image-slider-old__image');
						if (imgWrapOld) {
							imgWrapOld.classList.add('active');
						}
						const imgWrap = activeSlide.querySelector('.text-image-slider__image');
						if (imgWrap) {
							imgWrap.classList.add('active');
						}
					}, 10);
				}
			},
		});
	});

	const bannerSliders = document.querySelectorAll('.banner-slider');
	bannerSliders.forEach(slider => {
		const progressCircle = slider.querySelector(".autoplay-progress svg");
		const progressContent = slider.querySelector(".autoplay-progress span");
		const swiper = new Swiper(slider, {
			loop: true,
			spaceBetween: 20,
			navigation: {
				nextEl: slider.querySelector('.slider-nav__btn--next'),
				prevEl: slider.querySelector('.slider-nav__btn--prev'),
			},
			pagination: {
				el: slider.querySelector('.slider-pagination'),
				clickable: true,
			},
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			on: {
				autoplayTimeLeft(s, time, progress) {
					progressCircle.style.setProperty("--progress", 1 - progress);
				},
				// on change set header color based on slide data
				slideChange: function () {
					setTimeout(function () {
						const activeSlide = slider.querySelector('.swiper-slide-active');
						// play video in active slide if exist and stop in inactive slides
						const videos = slider.querySelectorAll('video');
						videos.forEach(video => {
							if (video !== activeSlide.querySelector('video')) {
								video.pause();
								video.currentTime = 0;
							} else {
								video.play();
							}
						});

						const headerSchemeEl = activeSlide.querySelector( '[data-header]' );
						const headerScheme = headerSchemeEl ? headerSchemeEl.dataset.header : null;
						const header = document.querySelector('.header');
						if (headerScheme === 'dark') {
							header.classList.add('header--dark');
							header.classList.remove('header--light');
						} else if (headerScheme === 'light') {
							header.classList.add('header--light');
							header.classList.remove('header--dark');
						}
					}, 100);
				}
			}
		});
	});

	const bannerAutoplayProgresses = document.querySelectorAll('.banner-slider .autoplay-progress');
	bannerAutoplayProgresses.forEach(progress => {
		progress.addEventListener('click', () => {
			const slider = progress.closest('.banner-slider');
			const swiperInstance = slider.swiper;
			const img = progress.querySelectorAll( 'img' );
			img.forEach(progress => {
				progress.classList.toggle('active');
			});
			if (swiperInstance.autoplay.running) {
				swiperInstance.autoplay.stop();
			} else {
				swiperInstance.autoplay.start();
			}
		});
	});

	const quoteCarousels = document.querySelectorAll('.quote-carousel');
	if (quoteCarousels) {
		quoteCarousels.forEach(slider => {
			const swiper = new Swiper(slider, {
				loop: true,
				speed: 800,
				spaceBetween: 20,
				navigation: {
					nextEl: slider.querySelector('.slider-nav__btn--next'),
					prevEl: slider.querySelector('.slider-nav__btn--prev'),
				},
				pagination: {
					el: slider.querySelector('.slider-pagination'),
					clickable: true,
				},
				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
				}
			});
		});
	}

	const numberSliders = document.querySelectorAll('.number-slider');
	numberSliders.forEach(slider => {
		const swiper = new Swiper(slider, {
			loop: true,
			speed: 800,
			spaceBetween: 20,
			navigation: {
				nextEl: slider.querySelector('.slider-nav__btn--next'),
				prevEl: slider.querySelector('.slider-nav__btn--prev'),
			},
			pagination: {
				el: slider.querySelector('.slider-pagination'),
				clickable: true,
			},
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			brakepoints: {
				320: {
					slidesPerView: 1,
					spaceBetween: 20,
				}
			},
		});
	});

	const postCarousels = document.querySelectorAll('.posts-carousel');
	if (postCarousels) {
		postCarousels.forEach(slider => {
			const swiper = new Swiper(slider, {
				loop: true,
				speed: 800,
				spaceBetween: 16,
				navigation: {
					nextEl: slider.querySelector('.slider-nav__btn--next'),
					prevEl: slider.querySelector('.slider-nav__btn--prev'),
				},
				pagination: {
					el: slider.querySelector('.slider-pagination'),
					clickable: true,
				},
				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
				},
				breakpoints: {
					320: {
						slidesPerView: 1,
						spaceBetween: 8,
					},
					640: {
						slidesPerView: 2,
						spaceBetween: 16,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 16,
					},
				}
			});
		});
	}

	const burger = document.querySelector('.header__burger');
	if (burger) {
		burger.addEventListener('click', () => {
			const nav = document.querySelector( '.header__nav' );
			document.querySelector( '.header__nav' ).classList.toggle('active');
			burger.classList.toggle('active');
		});
	}

	// Phone menu: collapsible submenus with caret toggles (CSS hides on larger screens)
	const caretSVG = `<svg viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg"><polyline points="1,1 6,7 11,1"/></svg>`;
	const navItems = document.querySelectorAll('.header__nav > ul > li');
	navItems.forEach(item => {
		const submenu = item.querySelector('.submenu');
		if (!submenu) return;
		item.classList.add('has-submenu');
		const link = item.querySelector(':scope > a');
		if (link) {
			const caret = document.createElement('span');
			caret.className = 'menu-caret';
			caret.innerHTML = caretSVG;
			link.appendChild(caret);
			caret.addEventListener('click', (e) => {
				if (window.innerWidth > 767) return;
				e.preventDefault();
				e.stopPropagation();
				const isOpen = item.classList.contains('submenu-open');
				navItems.forEach(other => other.classList.remove('submenu-open'));
				if (!isOpen) item.classList.add('submenu-open');
			});
		}
	});

	const accordions = document.querySelectorAll('.accordion-item');
	if (accordions) {
		accordions.forEach(accordion => {
			const header = accordion.querySelector('.accordion-item__heading');
			header.addEventListener('click', () => {
				accordion.classList.toggle('active');
				console.log(header);
				const content = accordion.querySelector('.accordion-item__content');
				if (accordion.classList.contains('active')) {
					content.style.height = content.scrollHeight + 'px';
				} else {
					content.style.height = 0;
				}
			});
		});
	}

	document.querySelectorAll('input[type="tel"]').forEach(function(input) {
		input.addEventListener('keydown', function(e) {

			const isAllowedKey = [
				173, 107, 109, 46, 8, 9, 27, 13, 110, 32, 190, 189 // backspace, delete, tab, escape, enter, space, . , - , + , /
			].includes(e.keyCode);

			const isNavigationKey = (e.keyCode >= 35 && e.keyCode <= 39); // home, end, left, right

			const isCtrlCommand = (e.ctrlKey || e.metaKey);
			const isControlShortcut = (
				(isCtrlCommand && e.keyCode === 65) || // Ctrl/Cmd+A
				(isCtrlCommand && e.keyCode === 67) || // Ctrl/Cmd+C
				(isCtrlCommand && e.keyCode === 88) || // Ctrl/Cmd+X
				(isCtrlCommand && e.keyCode === 86)    // Ctrl/Cmd+V
			);

			const isShiftedSymbol = (
				(e.shiftKey && e.keyCode === 187) || // + (shift + =)
				(e.shiftKey && e.keyCode === 57) ||  // ( (shift + 9)
				(e.shiftKey && e.keyCode === 48)     // ) (shift + 0)
			);

			if (isAllowedKey || isNavigationKey || isControlShortcut || isShiftedSymbol) {
				return;
			}

			const isMainKeypadNumber = (e.keyCode >= 48 && e.keyCode <= 57 && !e.shiftKey);
			const isNumpadNumber = (e.keyCode >= 96 && e.keyCode <= 105);

			if (!isMainKeypadNumber && !isNumpadNumber) {
				e.preventDefault();
			}
		});
	});
});

window.addEventListener('scroll', () => {
	const sections = document.querySelectorAll('[data-header]');
	const header = document.querySelector('.header');
	const headerBurger = document.querySelector('.header__burger');

	sections.forEach(section => {
		const rect = section.getBoundingClientRect();
		if (rect.top <= 0 && rect.bottom >= 0) {
			const headerScheme = section.dataset.header;
			if (headerScheme === 'dark') {
				header.classList.add('header--dark');
				header.classList.remove('header--light');
			} else if (headerScheme === 'light') {
				header.classList.add('header--light');
				header.classList.remove('header--dark');
			}
		}
	});
});

// add class "scrolled" to header if page is scrolled more than 50px
window.addEventListener('scroll', () => {
	const header = document.querySelector('.header');
	if (window.scrollY > 50) {
		header.classList.add('scrolled');
	} else {
		header.classList.remove('scrolled');
	}
});

// tooggle class "hidden" to header depending on scroll direction
// let lastScrollTop = 0;
// window.addEventListener('scroll', () => {
// 	const header = document.querySelector('.header');
// 	const currentScrollTop = window.scrollY;
// 	if (currentScrollTop > lastScrollTop) {
// 		header.classList.add('hidden');
// 	} else {
// 		header.classList.remove('hidden');
// 	}
// 	lastScrollTop = currentScrollTop;
// });

// window.addEventListener('load', () => {
// 	window.dispatchEvent(new Event('scroll'));
// });



function isInViewport(element) {
	const rect = element.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}


function checkImagesInView() {
	const images = document.querySelectorAll('.img-wrap, .text-image-slider__image, .text-image-slider-old__image, .staff__inner, .banner__pct img');
	images.forEach(image => {
		if (isInViewport(image.parentElement)) {
			image.classList.add('active');
		}
	});
}

window.addEventListener('scroll', checkImagesInView);
window.addEventListener('resize', checkImagesInView);
window.addEventListener('load', checkImagesInView);


function checkFadeInCascade() {
	const cascades = document.querySelectorAll('.fade-in-cascade');
	cascades.forEach(cascade => {
		if (isInViewport(cascade)) {
			const children = cascade.children;
			for (let i = 0; i < children.length; i++) {
				setTimeout(() => {
					children[i].classList.add('active');
				}, (i - 1) * 200); // delay of 200ms between each child
			}
		}
	});
}

window.addEventListener('scroll', checkFadeInCascade);
window.addEventListener('resize', checkFadeInCascade);
window.addEventListener('load', checkFadeInCascade);


function setHeaderHeightVariable() {
	const header = document.querySelector('.header');
	if (header) {
		const headerHeight = header.offsetHeight;
		document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
	}
}

window.addEventListener('resize', setHeaderHeightVariable);
window.addEventListener('load', setHeaderHeightVariable);

const filterItems = document.querySelectorAll('.filter input');
if (filterItems) {
	filterItems.forEach(item => {
		item.addEventListener('change', () => {
			filterItems.forEach(item => {
				if (item.checked) {
					const wrap = item.parentElement;
					if (wrap) {
						wrap.classList.add('active');
					}
				} else {
					const wrap = item.parentElement;
					if (wrap) {
						wrap.classList.remove('active');
					}
				}
			});
		});
	});
}

function closeCookieModal() {
	const cookieModal = document.querySelector('.cookies-modal');
	if (cookieModal) {
		cookieModal.classList.add('closed');
	}
}


document.addEventListener('DOMContentLoaded', () => {
	function copyLink() {
		const copyItems = document.querySelectorAll('.js-copy');

		copyItems.forEach(copyItem => {
			copyItem.addEventListener('click', (e) => {
				e.preventDefault();
				const text = copyItem.href || copyItem.textContent.trim();
				navigator.clipboard.writeText(text);
			});
		});
	}

	copyLink();
});

const bannerVideo = document.querySelector('.banner__pct video');
let pressed = false;
if (bannerVideo) {
	if (bannerVideo.paused && !pressed) {
		setTimeout( function () {
			const contents = document.querySelectorAll('.banner__content');
			if (contents) {
				contents.forEach(content => {
					content.addEventListener('click', (e) => {
						if (bannerVideo.paused) {
							bannerVideo.play();
							pressed = true;
						}
					});
				});
			}
		},100);
	}
}

